module.exports = __webpack_public_path__ + "front/img/8.6d347757.png";